import React, { useRef } from "react";
import { Button, FormControl, VStack, Image } from "@chakra-ui/react";
import { ProfileImg } from "../utils/Images";

const ProfileImageUpload = ({ profileImage, onImageChange }) => {
    const fileInputRef = useRef(null);

    return (
        <FormControl maxW="500px" mx="auto">
            <VStack>
                <Image
                    borderRadius="full"
                    boxSize="100px"
                    fallbackSrc={ProfileImg}
                    src={
                        profileImage
                            ? (profileImage instanceof File || profileImage instanceof Blob
                                ? URL.createObjectURL(profileImage)
                                : profileImage)
                            : ProfileImg
                    }
                />
                <Button
                    as="label"
                    htmlFor="profileImage"
                    variant="text"
                    aria-label="Add Profile Image"
                    onClick={() => fileInputRef.current && fileInputRef.current.click()}
                >
                    + Add Profile Image
                </Button>
                <input
                    id="profileImage"
                    name="profileImage"
                    type="file"
                    style={{ display: "none" }}
                    onChange={e => {
                        const file = e.target.files[0];
                        if (file) onImageChange(file);
                    }}
                    ref={fileInputRef}
                    accept="image/*"
                />
            </VStack>
        </FormControl>
    );
};

export default ProfileImageUpload; 